import { useState } from "react"
import { Icon, Icons } from "../../Components/Icon"
import { LogButton } from "../../Components/LogButton"
import { IShipStatus } from "../../Types"
import { SendAlertDialog } from "../UserAdvice/SendAlertDialog"
import { LogStatusViewProps } from "./Params"

// The pre-timeline status cell: renders the ship-status icon and, on an editable
// focus row with a create callback, the LogButton overlay (status + engine
// toggles). Extracted from LogView so the row composer stays lean. Keeps the
// original LogView-pre-timeline / LogView-status-icon class names.
export function LogStatusView({ createCallback, focusEditable, engines, hasNmeaEngineData, engineStatusCallback, initLogButtonMenuOpen, initLogButtonSubmenu, lightingCallback, lightingValue, lightingOptions, sails, sailChangesCallback, label, manualStatusActive, shipStatusValue, statusOptions }: LogStatusViewProps) {
  const [sendAlert, setSendAlert] = useState(false);
  const shipStatusIcon = <Icon key={`status-icon-${shipStatusValue}`} className="LogView-status-icon" icon={shipStatusValue == IShipStatus.none ? Icons.CircleLarge : `status-${IShipStatus[shipStatusValue]}`} />;

  return (
    <>
      <div className="LogView-pre-timeline">
        {createCallback ? (
          focusEditable ? (
            <LogButton
              createCallback={createCallback}
              disabled={false}
              engines={engines}
              hasNmeaEngineData={hasNmeaEngineData}
              engineStatusCallback={engineStatusCallback}
              initOpen={initLogButtonMenuOpen}
              initOpenSubmenu={initLogButtonSubmenu}
              lightingCallback={lightingCallback}
              lightingValue={lightingValue}
              lightingOptions={lightingOptions}
              label={label}
              manualStatusActive={manualStatusActive}
              onSendAlert={() => setSendAlert(true)}
              sails={sails}
              saveSails={sailChangesCallback}
              shipStatusIcon={shipStatusIcon}
              shipStatusValue={shipStatusValue}
              statusOptions={statusOptions}
            />
          ) : shipStatusIcon
        ) : (
          <>
            {shipStatusIcon}
          </>
        )}
      </div>
      {sendAlert && <SendAlertDialog onClose={() => setSendAlert(false)} />}
    </>
  );
}
